import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { LocaleProvider } from "./contexts/LocaleContext";
import { LoadingProvider } from "./contexts/LoadingContext.jsx";
import "./index.css";
import App from "./App.jsx";

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <LocaleProvider>
      <LoadingProvider>
        <App />
      </LoadingProvider>
    </LocaleProvider>
  </StrictMode>
);
